import PropTypes from "prop-types"

import { Button, Link, Typography } from "@mui/material"

import "./style.scss"

const NoResults = ({ search, clear, track }) => {
  const contactUs = () => {
    window.Intercom("showNewMessage", `Help, I can't find the ${search} dataset`)
    track()
  }
  return <div className="no-results">
    <Typography variant="h6">No matching results</Typography>
    <div className="text">
      <Typography variant="subtitle1">Can&apos;t find what you&apos;re looking for ?</Typography>
      <Typography variant="subtitle1">Try using more general search terms or contact us to help you look for a dataset that is currently not listed.</Typography>
    </div>
    <Button className="button" component={Link} aria-label="Clear search" onClick={clear}>Clear search</Button>
    <Button className="button" component={Link} aria-label="Contact Us" onClick={contactUs}>Contact Us</Button>
  </div>
}

NoResults.propTypes = {
  search: PropTypes.string.isRequired,
  clear: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
}

export default NoResults
